export default __webpack_public_path__ + "static/media/3536 knife block C top.40cd541f.png";